import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeviewcirclonComponent } from './treeviewcirclon/treeviewcirclon.component';
import { TreeModule } from '@circlon/angular-tree-component';
import * as PlotlyJS from 'plotly.js/dist/plotly.js';
import { PlotlyModule } from 'angular-plotly.js';
import { PlotlyComponent } from './plotly/plotly.component';
import { ToastrModule } from 'ngx-toastr';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { MaterialModule } from '../../../src/app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TableComponent } from './table/table.component';
import { SelectComponent } from './select/select.component';
import { TabsdisbleComponent } from './tabsdisble/tabsdisble.component';
import { DaterangepickerComponent } from './daterangepicker/daterangepicker.component';
import { RingchartComponent } from './ringchart/ringchart.component';
import { PiechartComponent } from './piechart/piechart.component';
import { GradientchartComponent } from './gradientchart/gradientchart.component';
import { FilterComponent } from './filter/filter.component';
import { GaugeComponent } from './gauge/gauge.component';
import { GaugepercentComponent } from './gaugepercent/gaugepercent.component';
import { DadqchartComponent } from './dadqchart/dadqchart.component';
import { QuickrangeComponent } from './quickrange/quickrange.component';
import { KpichartComponent } from './kpichart/kpichart.component';
import { DadqboxComponent } from './dadqbox/dadqbox.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { ProgressBarColor } from './progressbar/progress-bar-color';
import { CommontabsComponent } from './commontabs/commontabs.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { CommonselectComponent } from './commonselect/commonselect.component';
import { TreeDropdownComponent } from './tree-dropdown/tree-dropdown.component';
import { NextDirective } from './directives/next.directive';
import { PrevDirective } from './directives/prev.directive';
PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
    TreeviewcirclonComponent,
    PlotlyComponent,
    TableComponent,
    SelectComponent,
    TabsdisbleComponent,
    DaterangepickerComponent,
    RingchartComponent,PiechartComponent,
    GradientchartComponent,
    FilterComponent,
    GaugeComponent,
    GaugepercentComponent,
    DadqchartComponent,
    QuickrangeComponent,
    KpichartComponent,
    DadqboxComponent,
    SpinnerComponent,
    ProgressbarComponent,
    ProgressBarColor,
    CommontabsComponent,
    DropdownComponent,
    CommonselectComponent,
    TreeDropdownComponent,
    NextDirective,
    PrevDirective,
  ],
  imports: [
    CommonModule,
    TreeModule,
    PlotlyModule,
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgbModule,
    NgSelectModule,
  ],
  exports: [
    TreeviewcirclonComponent,
    PlotlyComponent,
    TableComponent,
    SelectComponent,
    TabsdisbleComponent,
    DaterangepickerComponent,
    RingchartComponent,PiechartComponent,
    GradientchartComponent,
    FilterComponent,
    GaugeComponent,
    GaugepercentComponent,
    DadqchartComponent,
    QuickrangeComponent,
    KpichartComponent,
    DadqboxComponent,
    SpinnerComponent,
    ProgressbarComponent,
    CommontabsComponent,
    DropdownComponent,
    CommonselectComponent,
    TreeDropdownComponent,
    NextDirective,
    PrevDirective
  ],
})
export class SharedModule {}
